import { ApiResponse, ICreateOptions, IDeleteOptions, IReadMultipleOptions, IReadOptions, IUpdateOptions } from "../models";
import { IEntity, IMultipleEntities } from "../../base/types";

import { rootApi } from "../rootApi";

const tableDataApi = rootApi.injectEndpoints({
  overrideExisting: false,

  endpoints: builder => ({
    read: builder.query<IEntity, IReadOptions>({
      query: (options) => ({
        url: `/${options.portalId}/TableData/Read(${options.tableId})`,
        headers: { 'info-query': JSON.stringify(options) }
      }),
      transformResponse: (res: ApiResponse) => {
        return JSON.parse(res.value) as IEntity;
      },
      providesTags: (result, err, arg) => {
        if (err) return [];

        const type = `${arg.tableId}` as const
        return [type]
      }
    }),

    readMultiple: builder.query<IMultipleEntities, IReadMultipleOptions>({
      query: (request) => {
        return {
          url: `/${request.portalId}/TableData/ReadMultiple(${request.tableId})`,
          headers: { 'info-query': JSON.stringify(request) }
        }
      },
      transformResponse: (res: ApiResponse) => {
        return JSON.parse(res.value) as IMultipleEntities;
      },
      providesTags: (result, err, arg) => {
        if (err) return [];

        const type = `${arg.tableId}` as const
        return [type]
      }
    }),

    create: builder.mutation<IEntity, ICreateOptions>({
      query: (request) => {
        return {
          url: `/${request.portalId}/TableData/Create(${request.tableId})`,
          method: 'POST',
          body: request
        }
      },
      transformResponse: (res: ApiResponse) => {
        return JSON.parse(res.value) as IEntity;
      },

      invalidatesTags: (result, err, arg) => {
        if (err) return [];

        const type = `${arg.tableId}` as const
        return [{ type }, type]
      }
    }),

    update: builder.mutation<IEntity, IUpdateOptions>({
      query: (request) => {
        return {
          url: `/${request.portalId}/TableData/Update(${request.tableId})`,
          method: 'PATCH',
          body: request
        }
      },
      transformResponse: (res: ApiResponse) => {
        return JSON.parse(res.value) as IEntity;
      },
      invalidatesTags: (result, err, arg) => {
        if (err) return [];

        const type = `${arg.tableId}` as const
        return [type]
      }
    }),

    delete: builder.mutation<void, IDeleteOptions>({
      query: (request) => {
        return {
          url: `/${request.portalId}/TableData/Delete(${request.tableId})`,
          method: 'DELETE',
          headers: { 'info-query': JSON.stringify(request) }
        }
      },
      invalidatesTags: (result, err, arg) => {
        if (err) return [];

        const type = `${arg.tableId}` as const
        return [type]
      }
    })
  })
})

export const {
  useReadQuery,
  useLazyReadQuery,
  useReadMultipleQuery,
  useLazyReadMultipleQuery,
  useCreateMutation,
  useUpdateMutation,
  useDeleteMutation,
} = tableDataApi;